import React from 'react';
import styles from './PromoCard.module.css';

const PromoCard: React.FC = () => (
  <div className={styles.card}>
    <p className={styles.text}>
      Find every
      <br />
      metric here
    </p>
  </div>
);

export default PromoCard;
